import { render } from "./Instrument.vue?vue&type=template&id=1ca7930e"
import script from "./Instrument.vue?vue&type=script&lang=js"
export * from "./Instrument.vue?vue&type=script&lang=js"

import "./Instrument.vue?vue&type=style&index=0&id=1ca7930e&lang=scss"

import exportComponent from "/home/runner/work/polissonos-web/polissonos-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__